module.exports = __webpack_public_path__ + "static/media/revenge-of-the-sith-thumb.bff2e051.png";